import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null); // start closed for a cleaner look

  const faqs = [
    { question: 'What services does BuzzMinded provide?', answer: 'BuzzMinded is a full-service digital marketing agency in Anand, Gujarat, offering SEO, social media marketing, Google Ads (PPC), Meta Ads, website design and development, graphic design, branding, content marketing, email marketing, logo design, video editing, and complete digital marketing solutions for businesses of all sizes.' },
    { question: 'Where is BuzzMinded located?', answer: 'BuzzMinded is based in Anand, Gujarat, and serves businesses across Gujarat, India, and international clients through online marketing services.' },
    { question: 'Why should I choose BuzzMinded?', answer: 'BuzzMinded focuses on data-driven marketing strategies, creative designs, transparent communication, and measurable results. Our goal is to help businesses increase website traffic, generate quality leads, improve brand visibility, and grow revenue.' },
    { question: 'Can you help my business rank on Google?', answer: "Absolutely. We use ethical White Hat SEO techniques to improve your website's visibility on Google and other search engines, helping you attract more organic traffic and potential customers." },
    { question: 'Can small businesses benefit?', answer: 'Absolutely. Digital marketing helps small businesses increase brand awareness, attract local customers, generate leads, and compete with larger companies at a cost-effective budget.' },
    { question: 'What makes BuzzMinded different?', answer: 'BuzzMinded combines creativity with performance-driven marketing. We focus on customized strategies, transparent reporting, modern design, local market expertise, and long-term client relationships.' },
    { question: 'Do you offer customized packages?', answer: 'Yes. Every business is different, so we create customized digital marketing and graphic design packages based on your goals, budget, and industry.' },
    { question: 'Can I hire you if I am outside Gujarat?', answer: 'Yes. We work with clients across India and internationally through virtual meetings, online project management, and digital collaboration.' }
  ];

  return (
    <section id="faq" className="faq-section" style={{ padding: '100px 0', background: '#050505' }}>
      <div className="container">
        <div className="section-header text-center" style={{ marginBottom: '60px' }}>
          <h2 className="section-title">
            Frequently Asked <span className="text-gradient-teal-gold">Questions</span>
          </h2>
          <p className="section-subtitle">Everything you need to know about partnering with us.</p>
        </div>

        <div className="faq-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))', gap: '24px' }}>
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => setOpenIndex(index === openIndex ? null : index)}
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer', transition: 'all 0.3s ease', height: 'fit-content' }}
            >
              <div className="faq-question" style={{ padding: '24px', fontSize: '18px', fontWeight: '600', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {faq.question}
                <span className="faq-icon" style={{ color: 'var(--primary-teal)', fontSize: '24px', transform: openIndex === index ? 'rotate(45deg)' : 'rotate(0)', transition: 'transform 0.3s ease' }}>
                  +
                </span>
              </div>
              <div 
                className="faq-answer-wrapper" 
                style={{ 
                  maxHeight: openIndex === index ? '500px' : '0', 
                  overflow: 'hidden', 
                  transition: 'all 0.4s ease-in-out',
                  padding: openIndex === index ? '0 24px 24px' : '0 24px',
                  opacity: openIndex === index ? 1 : 0
                }}
              >
                <div style={{ color: 'var(--text-muted)', lineHeight: '1.6' }}>{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center" style={{ marginTop: '60px' }}>
          <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>Still have questions?</p>
          <a href="#cta"><button className="btn-primary">Contact Support</button></a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
